$(function() {
  $('.csj .map>.right .list2>li>p').click(function () {
    if($(this).parent().hasClass('active')){
      $('.aboutus .career #global .map .mapleft .mapclick').removeClass('active');
      $('.csj .map>.right .list2>li').removeClass('active');
    }else{
      $('.csj .map .mapleft .mapclick').removeClass('active');
      $('.csj .map .mapleft .mapclick.m'+$(this).parent().index()).addClass('active');
      $('.csj .map>.right .list2>li').removeClass('active');
      $(this).parent().addClass('active');
    }
    $('.csj .map>.right').animate({'scrollTop':'0'},300);
  });
  $('.csj .map .mapleft .mapclick').click(function(){
    var a=$(this).attr('data');
    $('.csj .map .mapleft .mapclick').removeClass('active');
    $(this).addClass('active');
    $('.csj .map>.right .list2>li').removeClass('active');
    $('.csj .map>.right .list2>li:nth-child('+a+')').addClass('active');
    $('.csj .map>.right').animate({'scrollTop':'0'},300);
  });
});
